import { useCallback } from "react";
import { graphql, useMutation } from "react-relay";

import type {
  inviteUsersMutation,
  organizationpermission,
} from "__generated__/inviteUsersMutation.graphql";

export const InviteUsersMutation = graphql`
  mutation inviteUsersMutation(
    $orgId: ID!
    $emails: [String!]!
    $orgPermission: organizationpermission
    $resourceGroupLinks: [ResourceGroupLinkInput]
    $expiry: DateTime
  ) {
    inviteUsers(
      orgId: $orgId
      emails: $emails
      orgPermission: $orgPermission
      resourceGroupLinks: $resourceGroupLinks
      expiry: $expiry
    ) {
      invitedUsers
      errors
    }
  }
`;

interface ResourceGroupLinkInput {
  resourceGroupNodeId: string;
  resourceGroupPermission: organizationpermission;
}

export const useInviteUsers = (
  onCompleted?: (response: inviteUsersMutation["response"]) => void
) => {
  const [inviteUsers, loading] = useMutation<inviteUsersMutation>(InviteUsersMutation);

  return {
    inviteUsers: useCallback(
      (
        orgId: string,
        emails: string[],
        orgPermission: organizationpermission,
        resourceGroupLinks: ResourceGroupLinkInput[],
        expiry: string | null
      ) => {
        inviteUsers({
          variables: { orgId, emails, orgPermission, resourceGroupLinks, expiry },
          onCompleted,
        });
      },
      [inviteUsers, onCompleted]
    ),
    loading,
  };
};
